module.exports = __webpack_public_path__ + "static/media/sad.92d26a76.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/sad.png
 ** module id = 89
 ** module chunks = 0
 **/